import script from "./SelectInput.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectInput.vue?vue&type=script&setup=true&lang=js"

import "./SelectInput.vue?vue&type=style&index=0&id=4daa693f&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4daa693f"]])

export default __exports__